import { BRAND_NAME, BRAND_SUBTITLE } from "@/config/brand";

export default function BrandWordmark({
  align = "center",
  light = false,
  name = BRAND_NAME,
  subtitle = BRAND_SUBTITLE,
}: {
  align?: "left" | "center";
  light?: boolean;
  name?: string;
  subtitle?: string;
}) {
  const textAlign = align === "left" ? "left" : "center";

  return (
    <div style={{ textAlign }}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          color: light ? "#FFFFFF" : "#E8752D",
          maxWidth: "100%",
        }}
      >
        <span
          style={{
            height: 1,
            width: 32,
            background: light ? "rgba(255,255,255,0.32)" : "rgba(232, 117, 45, 0.22)",
            flexShrink: 0,
          }}
        />
        <span
          style={{
            fontSize: 34,
            lineHeight: 1,
            fontWeight: 800,
            letterSpacing: "0.02em",
            fontFamily: "\"Trebuchet MS\", \"Segoe UI\", sans-serif",
            textTransform: "lowercase",
          }}
        >
          {name}
        </span>
        <span
          style={{
            height: 1,
            width: 32,
            background: light ? "rgba(255,255,255,0.32)" : "rgba(232, 117, 45, 0.22)",
            flexShrink: 0,
          }}
        />
      </div>
      <p
        style={{
          marginTop: 10,
          fontSize: 13,
          lineHeight: 1.6,
          letterSpacing: "0.08em",
          color: light ? "rgba(255,255,255,0.76)" : "#C9B8A3",
        }}
      >
        {subtitle}
      </p>
    </div>
  );
}
